import { formatNumericDate, getTimeInHoursAndMins } from '../../utils/dates';
import { getPriorityForTable } from '../../utils/priority';

const tablesData = {
// ROUTES
  routesData: [{
    id: 1,
    organization_id: 1,
    name: 'Route A',
    description: 'Long Route',
    date: '2022-05-01',
    number_of_stops: 2,
    total_distance: 1040.5,
    total_time: 57924,
  },
  {
    id: 2,
    organization_id: 1,
    name: 'Route B',
    description: 'Short Route',
    date: '2022-04-01',
    number_of_stops: 1,
    total_distance: 3000,
    total_time: 20000,
  },
  {
    id: 3,
    organization_id: 1,
    name: 'Route C',
    description: 'Mini Route',
    date: '2022-03-01',
    number_of_stops: 0,
    total_distance: 500,
    total_time: null,
  },
  {
    id: 4,
    organization_id: 1,
    name: 'Route D',
    description: 'Crazy Route',
    date: '2022-02-01',
    number_of_stops: 8,
    total_distance: null,
    total_time: 40000,
  },
  {
    id: 5,
    organization_id: 1,
    name: 'Route E',
    description: 'Vacation Route',
    date: '2022-01-01',
    number_of_stops: 6,
    total_distance: 5,
    total_time: null,
  }],
  routesColumns: [
    {
      title: 'Name', dataIndex: 'name', className: 'inline-flex w-96', isSortable: true,
    },
    {
      title: 'Date', dataIndex: 'date', render: (text) => formatNumericDate(text), className: 'inline-flex w-32', isSortable: true,
    },
    {
      title: 'Sites', dataIndex: 'number_of_stops', className: 'inline-flex w-32', isSortable: true,
    },
    {
      title: 'Distance', dataIndex: 'total_distance', render: (text) => text && `${(text).toFixed(2)} mi`, className: 'inline-flex w-32', isSortable: true,
    },
    {
      title: 'Time', dataIndex: 'total_time', render: (text) => getTimeInHoursAndMins(text), className: 'inline-flex w-32', isSortable: true,
    },
  ],
  // CONTACTS
  contactsData: [
    {
      id: 29,
      name: 'Jack_contact29',
      company: 'Company37822',
      organization_id: 1,
      contact_type: 'Contractor',
      sites: 1,
      h2a: true,
      priority: 'high',
    },
    {
      id: 26,
      name: 'Max_contact26',
      company: 'Company38764',
      organization_id: 1,
      contact_type: 'Grower',
      sites: 2,
      priority: 'no_priority',
      h2a: true,
    },
    {
      id: 23,
      name: 'Donna_contact23',
      company: 'Company53144',
      organization_id: 1,
      contact_type: 'Worker',
      sites: 3,
      h2a: true,
    },
    {
      id: 21,
      name: 'Sam_contact21',
      company: 'Company65697',
      organization_id: 1,
      note: null,
      contact_type: 'Partner Organization',
      sites: 0,
      priority: 'low',
      h2a: true,
    },
    {
      id: 19,
      name: 'Jack_contact19',
      company: 'Company87200',
      organization_id: 1,
      contact_type: 'Contractor',
      sites: 1,
      priority: 'low',
      h2a: false,
    },
    {
      id: 17,
      name: 'Nixon_contact17',
      company: 'Company48271',
      organization_id: 1,
      contact_type: 'Grower',
      sites: 2,
      priority: 'low',
      h2a: false,
    },
    {
      id: 15,
      name: 'Fred_contact15',
      company: 'Company24395',
      organization_id: 1,
      contact_type: 'Contractor',
      priority: 'medium',
      h2a: false,
    },
    {
      id: 14,
      name: 'Sam_contact14',
      company: 'Company75137',
      organization_id: 1,
      contact_type: 'Contractor',
      sites: 0,
      priority: 'low',
      h2a: true,
    }],
  contactsColumns: [
    {
      title: 'Name', dataIndex: 'name', className: 'inline-flex w-40', isSortable: true,
    },
    {
      title: 'Contact type', dataIndex: 'contact_type', className: 'inline-flex w-48', isSortable: true,
    },
    {
      title: 'Company', dataIndex: 'company', className: 'inline-flex w-40', isSortable: true,
    },
    {
      title: 'Related sites', dataIndex: 'sites', className: 'inline-flex w-44', isSortable: true,
    },
    {
      title: 'Priority', dataIndex: 'priority', render: (value) => getPriorityForTable(value), className: 'inline-flex w-40', isSortable: true,
    },
    {
      title: 'H2a', dataIndex: 'h2a', render: (value) => (value ? 'Yes' : 'No'), className: 'inline-flex w-20', isSortable: true,
    },
  ],
};

export default tablesData;
